var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGraphicsAndPresentations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25,70h1.5c0-13.92871,7.58887-28.22308,24.5-29.20483V44.1333a.7502.7502,0,0,0,.75.75h8a.7502.7502,0,0,0,.75-.75v-3.25H61.32593a4.75,4.75,0,1,0,0-1.5H52.11987C64.91956,35.2478,70.75,22.48163,70.75,10h-1.5c0,13.92871-7.58887,28.22308-24.5,29.20483V36.1333a.7502.7502,0,0,0-.75-.75H36a.7502.7502,0,0,0-.75.75V39.25H18.67407a4.75,4.75,0,1,0,0,1.5h8.82154C14.96631,45.01624,9.25,57.6452,9.25,70ZM66,36.8833a3.25,3.25,0,1,1-3.25,3.25A3.25377,3.25377,0,0,1,66,36.8833Zm-29.25,0h6.5v6.5h-6.5ZM14,43.25A3.25,3.25,0,1,1,17.25,40,3.25377,3.25377,0,0,1,14,43.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGraphicsAndPresentations);
export default __webpack_public_path__ + "static/media/icon_graphics_and_presentations.687ed5d8db4409bf08f7a49693845d0e.svg";
export { ForwardRef as ReactComponent };